export default __webpack_public_path__ + "static/media/shirtly_ipad_3.a497c1cc.png";